jQuery( document ).ready(function($) {

    if ($(window).outerWidth() <= 1199) {

        $('.fluid').css({top:'90%',left:'50%',margin:'-'+($('.fluid').height() / 2)+'px 0 0 -'+($('.fluid').width() / 2)+'px'});

    }
    else{
        $('.fluid').css({top:'unset',left:'unset', margin:'unset'});
    }

    $(window).resize(function(){
        if ($(window).outerWidth() <= 1199) {

            $('.fluid').css({top:'90%',left:'50%',margin:'-'+($('.fluid').height() / 2)+'px 0 0 -'+($('.fluid').width() / 2)+'px'});

        }
        else{
            $('.fluid').css({top:'unset',left:'unset', margin:'unset'});
        }
    })
    
    $(window).scroll(function(){

        if(!$('#site-header-menu').hasClass('toggled-on')){
        
            if($(window).scrollTop() >= 50){
                $('.fluid').addClass('transformed');
            }
            else{
                $('.fluid').removeClass('transformed');
            }
        }
        
        
    })
    
    
   
});
